export default "__VITE_ASSET__44445dfe__"